import React from "react"

const CartContext = React.createContext({
  cartContents: [],
  cartId: null,
  cartDrawerOpen: false,
  cartCount: 0,
  cartState: "cart",
  address: null,
  clearCart: () => {},
  addToCart: () => {},
  updateCartCount: () => {},
  setCartState: () => {},
  setAddress: () => {},
})

export default CartContext
